<template>
  <div class="card">
    <div class="card-header">
      <div class="row">
        <div class="col-md-8">
          <strong class="card-title mb-3">P All Sum</strong>
        </div>
        <div class="col-md-3">
          <download :tableId="'pallsum'" :fileName="'p-all'"></download>
        </div>
        <div class="col-md-1">
          <goback></goback>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="row mb5">
        <div class="col-md-9 br">
          <div class="row">
            <div class="col-md-3">
              <div class="form-group">
                <datepicker
                  :input-class="'form-control'"
                  :format="'dd-MM-yyyy'"
                  v-model="ddate"
                  @selected="getDateData($event)"
                ></datepicker>
              </div>
            </div>
            <div class="col-md-3" v-if="searchData.length>0">
              <div class="form-group">
                <select class="form-control" v-model="selFilter[0]" name="raw-data-columns">
                  <option
                    v-for="(d, index) in filterOptions0"
                    v-bind:key="d.id+index"
                    :value="d.id"
                    disabled="disabled"
                  >{{d.value}}</option>
                </select>
              </div>
            </div>
            <div class="col-md-2" v-if="searchData.length>0">
              <div class="form-group">
                <!-- <label class="form-label">Max</label> -->
                <input class="form-control" v-model="minRange[0]" placeholder="Min">
              </div>
            </div>
            <div class="col-md-2" v-if="searchData.length>0">
              <div class="form-group">
                <!-- <label class="form-label">Max</label> -->
                <input class="form-control" v-model="maxRange[0]" placeholder="Max">
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <!-- <input type="text" v-model="searchParams.sectorname" class="form-control" name="sector" placeholder="Search by Sector"/> -->
                <select class="form-control" name="sector" v-model="sectorname">
                  <option value>Select Sector</option>
                  <option
                    v-for="(sec, index) in sectorData"
                    :value="sec.sect_name"
                    v-bind:key="sec.sect_code+index"
                  >{{sec.sect_name}}</option>
                </select>
              </div>
            </div>
            <div class="col-md-3" v-if="searchData.length>0">
              <div class="form-group">
                <select class="form-control" v-model="selFilter[1]" name="raw-data-columns">
                  <option
                    v-for="(d, index) in filterOptions1"
                    v-bind:key="d.id+index"
                    :value="d.id"
                    disabled="disabled"
                  >{{d.value}}</option>
                </select>
              </div>
            </div>
            <div class="col-md-2" v-if="searchData.length>0">
              <div class="form-group">
                <!-- <label class="form-label">Max</label> -->
                <input class="form-control" v-model="minRange[1]" placeholder="Min">
              </div>
            </div>
            <div class="col-md-2" v-if="searchData.length>0">
              <div class="form-group">
                <!-- <label class="form-label">Max</label> -->
                <input class="form-control" v-model="maxRange[1]" placeholder="Max">
              </div>
            </div>
            <div class="col-md-2" v-if="searchData.length>0"></div>
            <div class="col-md-3" v-if="searchData.length>0"></div>
            <div class="col-md-3" v-if="searchData.length>0">
              <div class="form-group">
                <select class="form-control" v-model="selFilter[2]" name="raw-data-columns">
                  <option
                    v-for="(d, index) in filterOptions2"
                    v-bind:key="d.id+index"
                    :value="d.id"
                  >{{d.value}}</option>
                </select>
              </div>
            </div>
            <div class="col-md-2" v-if="searchData.length>0">
              <div class="form-group">
                <input class="form-control" v-model="minRange[2]" placeholder="Min">
              </div>
            </div>
            <div class="col-md-2" v-if="searchData.length>0">
              <div class="form-group">
                <input class="form-control" v-model="maxRange[2]" placeholder="Max">
              </div>
            </div>
            <div class="col-md-1" >
              <div class="form-group">
                <button @click="filterData" class="btn btn-sm btn-primary" type="button">
                  <i class="fa fa-filter" title="Filter"></i>
                </button>
              </div>
            </div>
            <div class="col-md-1" >
              <div class="form-group">
                <button @click="refreshData" class="btn btn-sm btn-success" type="button">
                  <i class="fa fa-refresh" title="Refresh"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <input
              class="form-control"
              v-model="searchText"
              placeholder="Search"
              @keyup="filteredList($event)"
            >
          </div>
          <div class="form-group">
            <select class="form-control" v-model="selRangeFilter" @change="filterRangeData($event)">
              <option
                v-for="(d, index) in mcOptions"
                v-bind:key="d.id+index"
                :value="index"
              >{{d.value}}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="table-responsive app" v-dragscroll="true">
        <table
          id="pallsum"
          class="table table-bordered fonts11 app-inner" 
        >
          <thead>
            <tr>
              <!-- <th>Sr.</th> -->
              <th
                @click="sortColumn(field, index)"
                style="font-size:.92em"
                class="data-cell column-sort"
                v-for="(field, index, key) in tableFields"
                v-bind:key="'field'+field+index+key"
              >
                {{field.name}}
                <span v-if="field.isSortable">
                  <i
                    class="fa fa-caret-down"
                    v-if="(field.sort_order == 1 || field.sort_order == 0)"
                  ></i>
                  <i
                    class="fa fa-caret-up"
                    v-else-if="(field.sort_order == 2 || field.sort_order == 0)"
                  ></i>
                </span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in rawData" v-bind:key="'row'+row+index">
              <!-- <td>{{index+1}}</td> -->
              <td v-for="field in tableFields" v-bind:key="'td'+field.title+index">
                <span v-if="field.isLink">
                  <a class="a-btn" @click.prevent="showCompDetails(row)">{{ row[field.title]}}</a>
                </span>
                <span
                  v-if="field.title==='date'"
                >{{(row[field.title])? getDate(row[field.title]): '-'}}</span>
                <span
                  v-if="field.title!=='date' && !field.isLink"
                >{{(field.isNumeric)? getFixed(row[field.title]): row[field.title]}}</span>
                <!-- <span>{{(row[field.title] !== null)? getFixed(row[field.title]): (row[field.title]==0 || row[field.title]=="0")? 0:'-'}}</span> -->
              </td>
            </tr>
          </tbody>
        </table>
        <div class="alert alert-danger" role="alert" v-if="rawData.length===0">No data found!</div>
      </div>
      <!-- <div class="row" v-else>
        <div class="col-md-12">
          <div class="alert alert-danger" role="alert">No data found!</div>
        </div>
      </div> -->
    </div>
  </div>
</template>
<script>
import http from "@/lib/http";
import Datepicker from "vuejs-datepicker";
import { commonMixins } from "../../assets/mixins/common.js";

export default {
  components: { Datepicker },
  mixins: [commonMixins],
  props: ["company"],
  created() {
    // if (this.filterOptions.length > 0 &&  this.filterOptions.length > 1) {
      this.selFilter[0] = 'p11_S';
      this.selFilter[1] = 'q1_a_b_greater';
      this.selFilter[2] = 'p11_quarterly_trends';
      this.minRange[0] = this.minRange[1] = this.minRange[2] = this.maxRange[0] = this.maxRange[1] = this.maxRange[2] = "";
    // } else {
    //   this.selFilter[0] = this.selFilter[1] = this.selFilter[2] = "";
    //   this.minRange[0] = this.minRange[1] = this.minRange[2] = this.maxRange[0] = this.maxRange[1] = this.maxRange[2] = "";
    // }
    this.getRawData();
    this.getSectorData();
  },
  data() {
    return {
      ddate: new Date().setDate(new Date().getDate() - 1),
      rawDataType: 0,
      tableFields: [],
      rawDataList: [],
      rawDataApi: "getAllSumData",
      rawData: {},
      searchData: [],
      searchText: "",
      curYear: new Date().getFullYear(),
      minRange: [],
      maxRange: [],
      filterOptions: [
        {
          id: "",
          value: "Select",
          isNumeric: true,
          sort_order: 0
        },
      ],
      selFilter: [],
      selRangeFilter: 0,
      mcOptions: [
        { id: 0, value: "All", min: "", max: "" },
        { id: 1, value: "MC > 20000", min: 20000, max: "" },
        { id: 2, value: "5000 <= MC <= 20000", min: 5000, max: 20000 },
        { id: 3, value: "1000 <= MC <= 5000", min: 1000, max: 5000 },
        { id: 4, value: "MC <= 1000", min: "", max: 1000 }
      ],
      sectorname: "",
      sectorData: [],
      type: "all"
    };
  },
  methods: {
    getRawData() {
      this.rawData = {};
      this.tableFields = [];
      let myself = this;
      http.post(
        this.rawDataApi,
        {
          my_date: this.getDate(this.ddate),
          m_filter: this.selFilter,
          min_range: this.minRange,
          max_range: this.maxRange,
          sector: this.sectorname
        },
        (error, response) => {
          console.log(response, error);
          this.rawData = response;
          this.searchData = response;
          if (response.length > 0) {
            var rawData = response; 
            var tableFields = Object.keys(response[0]);
            console.log("tableFields", tableFields);
            tableFields.forEach((val, key)=>{
              console.log(key, val);
              if(val!=='date' && val!=='_id'){
                this.tableFields.push({
                  title: val,
                  name: (this.getCustomLabel(val))? this.getCustomLabel(val): this.getLabel(val),
                  isNumeric: (val==='co_code' || val==='name' || val==='sector_name')? false: true,
                  sort_order: (val==='co_code')? 0: (val==='name')? 1:(val==='sector_name')? 2:(val==='market_capitalization')? 3: (val==='p1_S')? 4:(val==='p2_S')? 5:(val==='p3_S')? 6:(val==='p4_S')? 7:(val==='p5_a_S')? 8:(val==='p5_b_S')? 9:(val==='p6_a')? 10:(val==='p6_b')? 11:(val==='p7_a_S')? 12:(val==='p7_b_S')? 13:(val==='p8_a_S')? 14: (val==='p8_b_S')? 15:(val==='p9_S')? 16: (val==='p10_S')? 17:(val==='p11_S')? 18: (val==='q1_S')? 19: (val==='q1_a_S')? 20: (val==='q1_b_S')? 21:(val==='q1_c_S')? 22:(val==='q1_d_S')? 22:999,
                  isLink: 0,
                  isSortable: 1
                });
              }
              if(val!=='date' && val!=='_id' && val!=='name' && val!=='co_code' && val!=='sector_name'){
                this.filterOptions.push({
                    id: val,
                    value: (this.getCustomLabel(val))? this.getCustomLabel(val): this.getLabel(val),
                    isNumeric: true,
                    sort_order: (val==='market_capitalization')? 3: (val==='p1_S')? 4:(val==='p2_S')? 5:(val==='p3_S')? 6:(val==='p4_S')? 7:(val==='p5_a_S')? 8:(val==='p5_b_S')? 9:(val==='p6_a')? 10:(val==='p6_b')? 11:(val==='p7_a_S')? 12:(val==='p7_b_S')? 13:(val==='p8_a_S')? 14: (val==='p8_b_S')? 15:(val==='p9_S')? 16: (val==='p10_S')? 17:(val==='p11_S')? 18: (val==='q1_S')? 19: (val==='q1_a_S')? 20: (val==='q1_b_S')? 21:(val==='q1_c_S')? 22:(val==='q1_d_S')? 22:999,
                  });
              }
            });
            this.tableFields = this.sorted_fields_date_asc(this.tableFields, 'sort_order');
            console.log(this.tableFields);
            this.filterOptions = this.sorted_fields_date_asc(this.filterOptions, 'sort_order');
            myself.rawData = rawData;
            myself.searchData = rawData;
            // console.log(new Date(myself.rawData[0].date));
            if (myself.rawData[0].date)
              myself.ddate = new Date(myself.rawData[0].date);
            console.log(myself.searchData);
          }
        }
      );
    },
    filterRangeData(event) {
      this.clearData();
      var ind = event.target.value;
      this.selRangeFilter = this.mcOptions[ind].id;
      if (this.selRangeFilter === 0) {
        this.rawData = this.searchData;
        return this.rawData;
      } else {
        var minRange = this.mcOptions[ind].min;
        var maxRange = this.mcOptions[ind].max;
        this.rawData = this.searchData.filter(rd => {
          console.log(rd, this.selRangeFilter, maxRange, minRange);
          if (minRange != "" && maxRange != "") {
            return (
              parseInt(rd["market_capitalization"]) >= parseInt(minRange) &&
              parseInt(rd["market_capitalization"]) <= parseInt(maxRange)
            );
          } else {
            if (minRange != "") {
              return (
                parseInt(rd["market_capitalization"]) >= parseInt(minRange)
              );
            }
            if (maxRange != "") {
              return (
                parseInt(rd["market_capitalization"]) <= parseInt(maxRange)
              );
            }
          }
        });
      }

      console.log("rawData", this.rawData);
      setTimeout(() => {
        this.sortColumn(this.tableFields[2], 2);
      });
    },
    filterData() {
      // if (this.selFilter !== "") {
      this.getRawData();
      // } else {
      //   this.$toastr.error("Please select field", "Error", {});
      // }
    },
    filteredList(e) {
      this.selRangeFilter = 0;
      this.selFilter = "";
      if (this.searchText === null || this.searchText === "") {
        this.rawData = this.searchData;
        return this.rawData;
      } else if (this.searchText.length <= 2) {
        this.rawData = this.searchData;
        return this.rawData;
      }
      if (this.searchText.length > 2 || e.keyCode === 13) {
        this.rawData = this.searchData.filter(rd => {
          return (
            rd.co_code.toLowerCase().includes(this.searchText.toLowerCase()) ||
            (rd.name
              ? rd.name.toLowerCase().includes(this.searchText.toLowerCase())
              : false)
          );
        });
      }
    },
    getSectorData() {
      let _this = this;
      http.get("getSectorList", {}, function(error, response) {
        // console.log("Sector Data", response);
        _this.sectorData = response;
      });
    },
    clearData() {
      this.selRangeFilter = 0;
      this.selFilter = "";
      this.searchText = "";
      this.rawData = this.searchData;
    },
    refreshData(){
      this.sectorname = "";
      this.searchText = "";
      this.selFilter[2] = 'p11_quarterly_trends';
      this.ddate = new Date().setDate(new Date().getDate() - 1);
      this.minRange[0] = this.minRange[1] = this.minRange[2] = this.maxRange[0] = this.maxRange[1] = this.maxRange[2] = "";
      this.getRawData();
    },
    getDateData(e) {
      console.log("Event ", e);
      console.log("Changed ", this.ddate);
    }
  },
  computed: {
    filterOptions0: function(){
      return this.filterOptions.filter(function(row, index) {
        return row.id === "p11_S";
      });
    },
    filterOptions1: function(){
      return this.filterOptions.filter(function(row, index) {
        return row.id === "q1_a_b_greater";
      });
    },
    filterOptions2: function(){
      return this.filterOptions.filter(function(row, index) {
        return row.id === "p11_quarterly_trends"
        // return row.id === "q1_S" || row.id === "q1_a_S" || row.id === "q1_b_S" || row.id === "q1_c_S" || row.id === "q1_d_S";
      });
    }
  }
};
</script>
<style>
form .col-md-3 {
  width: 40%;
}

.table td {
  padding: 5px 10px 5px 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/market-data/allSumData.vue